module.exports = __webpack_public_path__ + "static/media/KalgoorlieMiner-devicecomp-min.2e4d0647.png";